import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    affiliate: {
      registration_reference: {
        header: 'HEADER',
        copy: 'COPY',
        link: 'LINK',
        show_condition_btn: 'SHOW_CONDITION_BTN',
        condition: {
          header: 'CONDITION_HEADER',
          back: 'BACK',
          form: {
            title: 'FORM_TITLE',
            description: 'FORM_DESCRIPTION',
          },
          step: {
            step: 'STEP',
          },
        },
      },
    },
  }));
}
